import validate from "/home/leandro/_git/baeta-advocacia/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_better-sqlite3@11._2f7dydcu443ytkks3h3avydaau/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/leandro/_git/baeta-advocacia/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_better-sqlite3@11._2f7dydcu443ytkks3h3avydaau/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}